// Design system color tokens: Tonal palettes + derived light/dark tokens
export const TonalPalettes = {
    primary: {
        0: "#000000",
        5: "#020002",
        10: "#0e000b",
        15: "#1e001a",
        20: "#30002a",
        25: "#42003b",
        30: "#56004d",
        35: "#6a005f",
        40: "#7f0073",
        45: "#950087",
        50: "#ac009b",
        55: "#c300b0",
        60: "#da00c5",
        root: "#ea00d4",
        70: "#fe30e7",
        80: "#ff82f5",
        90: "#ffc2fd",
        95: "#ffdeff",
        98: "#ffeeff",
        99: "#fff4ff",
        100: "#ffffff",
    },
    secondary: {
        0: "#000000",
        5: "#010005",
        10: "#080018",
        15: "#15002d",
        20: "#230044",
        25: "#32005c",
        30: "#420075",
        35: "#520090",
        40: "#6300ab",
        45: "#7500c7",
        50: "#8700e4",
        55: "#9700fb",
        root: "#9b00ff",
        60: "#a627ff",
        70: "#b974ff",
        80: "#d1a5ff",
        90: "#e9d1ff",
        95: "#f5e7ff",
        98: "#fdf3ff",
        99: "#fff7ff",
        100: "#ffffff",
    },
    success: {
        0: "#000000",
        5: "#000100",
        10: "#000601",
        15: "#001203",
        20: "#001f0a",
        25: "#002d13",
        30: "#003b1d",
        35: "#004a27",
        40: "#005931",
        45: "#00693c",
        50: "#007a47",
        55: "#008b52",
        60: "#009c5e",
        70: "#00bf76",
        80: "#00e390",
        root: "#00ffaa",
        90: "#1fffb0",
        98: "#d4ffea",
        99: "#e1fff1",
        100: "#ffffff",
    },
    error: {
        0: "#000000",
        5: "#030000",
        10: "#110000",
        15: "#230002",
        20: "#370005",
        25: "#4b000a",
        30: "#610012",
        35: "#780019",
        40: "#8f0021",
        45: "#a80029",
        50: "#c00031",
        55: "#da003a",
        60: "#f20044",
        root: "#ff004e",
        70: "#ff526b",
        80: "#ff979d",
        90: "#ffcbcc",
        95: "#ffe3e3",
        98: "#fff0f1",
        99: "#fff5f5",
        100: "#ffffff",
    },
    info: {
        0: "#000000",
        5: "#000009",
        10: "#010022",
        15: "#03003d",
        20: "#06005b",
        25: "#0b007a",
        30: "#11009b",
        35: "#1700bd",
        40: "#1d00e0",
        45: "#210cf5",
        root: "#2323ff",
        50: "#2631ff",
        55: "#3152ff",
        60: "#436cff",
        70: "#6d96ff",
        80: "#9bbbff",
        90: "#caddff",
        95: "#e1eeff",
        98: "#eff8ff",
        99: "#f4fcff",
        100: "#ffffff",
    },
    neutral: {
        0: "#000000",
        4: "#000003",
        5: "#010004",
        6: "#010005",
        root: "#010005",
        10: "#04020d",
        12: "#060411",
        15: "#0c0818",
        17: "#100c1d",
        20: "#161324",
        22: "#1b1829",
        24: "#201c2e",
        25: "#221f30",
        30: "#2e2b3d",
        35: "#3b374b",
        40: "#484559",
        45: "#555267",
        50: "#636075",
        55: "#726e84",
        60: "#807d93",
        70: "#9f9bb2",
        80: "#bebad2",
        87: "#d4d1e9",
        90: "#dedaf3",
        92: "#e5e1fa",
        94: "#ebe8ff",
        95: "#efebff",
        96: "#f2eeff",
        97: "#f5f2ff",
        98: "#f9f5ff",
        99: "#fcf9ff",
        100: "#ffffff",
    },
};
export const LightTokenMap = {
    primary: { palette: "primary", tone: 55 },
    onPrimary: { palette: "primary", tone: 100 },
    primaryContainer: { palette: "primary", tone: 90 },
    onPrimaryContainer: { palette: "primary", tone: 45 },
    secondary: { palette: "secondary", tone: 55 },
    onSecondary: { palette: "secondary", tone: 100 },
    secondaryContainer: { palette: "secondary", tone: 90 },
    onSecondaryContainer: { palette: "secondary", tone: 50 },
    success: { palette: "success", tone: 55 },
    onSuccess: { palette: "success", tone: 100 },
    successContainer: { palette: "success", tone: 95 },
    onSuccessContainer: { palette: "success", tone: 45 },
    error: { palette: "error", tone: 55 },
    onError: { palette: "error", tone: 100 },
    errorContainer: { palette: "error", tone: 90 },
    onErrorContainer: { palette: "error", tone: 45 },
    info: { palette: "info", tone: 55 },
    onInfo: { palette: "info", tone: 100 },
    infoContainer: { palette: "info", tone: 90 },
    onInfoContainer: { palette: "info", tone: 50 },
    surface: { palette: "neutral", tone: 99 },
    surfaceContainerLowest: { palette: "neutral", tone: 100 },
    surfaceContainerLow: { palette: "neutral", tone: 96 },
    surfaceContainer: { palette: "neutral", tone: 94 },
    surfaceContainerHigh: { palette: "neutral", tone: 92 },
    surfaceContainerHighest: { palette: "neutral", tone: 90 },
    onSurface: { palette: "neutral", tone: 30 },
    onSurfaceVariant: { palette: "neutral", tone: 45 },
    outline: { palette: "neutral", tone: 80 },
    outlineVariant: { palette: "neutral", tone: 87 },
    inverseSurface: { palette: "neutral", tone: 30 },
    inverseOnSurface: { palette: "neutral", tone: 95 },
    inversePrimary: { palette: "primary", tone: 80 },
    scrim: { palette: "neutral", tone: 0 },
    shadow: { palette: "neutral", tone: 0 },
};
export const DarkTokenMap = {
    primary: { palette: "primary", tone: 80 },
    onPrimary: { palette: "primary", tone: 20 },
    primaryContainer: { palette: "primary", tone: 45 },
    onPrimaryContainer: { palette: "primary", tone: 90 },
    secondary: { palette: "secondary", tone: 80 },
    onSecondary: { palette: "secondary", tone: 20 },
    secondaryContainer: { palette: "secondary", tone: 45 },
    onSecondaryContainer: { palette: "secondary", tone: 90 },
    success: { palette: "success", tone: 80 },
    onSuccess: { palette: "success", tone: 20 },
    successContainer: { palette: "success", tone: 50 },
    onSuccessContainer: { palette: "success", tone: 90 },
    error: { palette: "error", tone: 80 },
    onError: { palette: "error", tone: 20 },
    errorContainer: { palette: "error", tone: 50 },
    onErrorContainer: { palette: "error", tone: 90 },
    info: { palette: "info", tone: 80 },
    onInfo: { palette: "info", tone: 20 },
    infoContainer: { palette: "info", tone: 50 },
    onInfoContainer: { palette: "info", tone: 90 },
    surface: { palette: "neutral", tone: 15 },
    surfaceContainerLowest: { palette: "neutral", tone: 10 },
    surfaceContainerLow: { palette: "neutral", tone: 20 },
    surfaceContainer: { palette: "neutral", tone: 22 },
    surfaceContainerHigh: { palette: "neutral", tone: 24 },
    surfaceContainerHighest: { palette: "neutral", tone: 25 },
    onSurface: { palette: "neutral", tone: 94 },
    onSurfaceVariant: { palette: "neutral", tone: 80 },
    outline: { palette: "neutral", tone: 45 },
    outlineVariant: { palette: "neutral", tone: 35 },
    inverseSurface: { palette: "neutral", tone: 90 },
    inverseOnSurface: { palette: "neutral", tone: 20 },
    inversePrimary: { palette: "primary", tone: 40 },
    scrim: { palette: "neutral", tone: 0 },
    shadow: { palette: "neutral", tone: 0 },
};
function fromMap(map) {
    const out = {};
    Object.keys(map).forEach((k) => {
        const { palette, tone } = map[k];
        // @ts-ignore indexable
        out[k] = TonalPalettes[palette][tone];
    });
    return out;
}
export const colorsLight = fromMap(LightTokenMap);
export const colorsDark = fromMap(DarkTokenMap);
//# sourceMappingURL=colors.js.map